import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertModal, Text, TextLink } from '@modusign/design-system';

import useUsageCount from '@app/hooks/useUsageCount';

interface AttachmentExceededAlertModalProps {
  onConfirm: () => void;
}

function AttachmentExceededAlertModal({ onConfirm }: AttachmentExceededAlertModalProps) {
  const { attachmentRequestCount } = useUsageCount();

  return (
    <AlertModal
      isOpen
      maxWidth="xs"
      title="첨부파일 최대 개수 초과"
      variant="warning"
      onClose={onConfirm}
    >
      <Text>
        현재 요금제는 <Text color="textEmphasisBase">최대 {attachmentRequestCount.limit}개</Text>의
        파일을 요청하거나 첨부할 수 있습니다. 파일의 개수 또는 요금제를 변경해 주세요.
      </Text>
      <TextLink display="block" mt={4} to="/payment/plan-change">
        요금제 변경 <FontAwesomeIcon icon={faChevronRight} />
      </TextLink>
    </AlertModal>
  );
}

export default AttachmentExceededAlertModal;
